import { map } from 'lodash';
import { settings } from '~/config';

import { GET_SITE_MAIN_INFO } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  items: [],
  loaded: false,
  loading: false,
  result: {},
  common: {},
  current: {},
};

/**
 * Site Main Info Reducer
 * @param {*} state
 * @param {*} action
 */
export default function siteMainInfo(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SITE_MAIN_INFO}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_SITE_MAIN_INFO}_SUCCESS`:
      return {
        ...state,
        error: null,
        // items: map(action.result.items, item => ({
        //   ...item,
        //   '@id': item['@id'].replace(settings.apiPath, ''),
        // })),
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${GET_SITE_MAIN_INFO}_FAIL`:
      return {
        ...state,
        error: action.error,
        items: [],
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
